import { Button } from "@/shared/ui/button";
import { DialogClose } from "@/shared/ui/dialog";
import { Modal } from "@/shared/ui/Modal";

interface ProofsModalProps {
  files: string[];
}

export const ProofsModal = ({ files }: ProofsModalProps) => {
  return (
    <Modal>
      <Modal.Trigger>Раскрыть</Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Доказательства</Modal.Title>
        <div className="flex flex-col gap-32">
          <div className="flex gap-2">
            {files.map((file, index) => {
              return (
                <a
                  key={index}
                  href={file}
                  download={file}
                  className="text-sm text-[#3179FF] underline"
                >
                  {file}
                </a>
              );
            })}
          </div>
          <DialogClose>
            <Button className="w-full">Понятно</Button>
          </DialogClose>
        </div>
      </Modal.Content>
    </Modal>
  );
};
